import { defineMessages } from 'react-intl';

const messages = defineMessages({
    view: {
        id: "plan.view",
    },
})

export default messages;
